import { useAction, useAtom } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import styled from 'styled-components'

import { pairActivityModelAtom } from '../atoms'

import { PairActivitySnackbar } from './pair-activity-snackbar'

type PairActivityNotificationsProps = {}

export const PairActivityNotifications: React.FC<
  PairActivityNotificationsProps
> = () => {
  const [model] = useAtom(pairActivityModelAtom)
  const [notifications] = useAtom(model)
  const close = useAction(model.close)

  return (
    <Root>
      <AnimatePresence>
        {notifications.map((it) => (
          <motion.div
            key={it.id}
            layout
            initial={{ scale: 0, opacity: 0.3 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <PairActivitySnackbar
              onClose={() => {
                close(it.id)
              }}
              activity={it.activity}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </Root>
  )
}

const Root = styled.div`
  position: fixed;
  display: grid;
  justify-content: center;
  justify-items: center;
  align-content: start;
  z-index: 10;

  inset: 0;

  padding: 10px;
  pointer-events: none;
  background: transparent;
`
